import styles from "./HomeHero.module.css";
import {Link} from "react-router-dom";

function HomeHero() {
    return (
        <section className={ styles.hpHero } >
            <div className={ styles.hpHeroBg } />
            <div className={ styles.hpHeroGrid } />
            <div className={ styles.hpHeroInner } >
                <div>
                    <div className={ styles.hpHeroTag } >
                        <div className={ styles.hpHeroTagLine } />
                        100% Free · No Credit Card
                    </div>
                    <h1>
                        Learn to code &<br />
                        <em>build real things.</em>
                    </h1>
                    <p className={ styles.hpHeroSub } >
                        Structured courses in programming and data science. Track your progress, earn certificates, and join a community of learners. Completely free.
                    </p>
                    <div className={ styles.hpHeroActions } >
                        <Link to="registration" className={ styles.hpBtnPrimary } >Start Learning →</Link>
                        <Link to="/courses" className={ styles.hpBtnGhost } >Browse Courses</Link>
                    </div>
                    <div className={ styles.hpHeroStats } >
                        {[["11k+", "Active learners"], ["25+", "Free courses"], ["84%", "Completion rate"]].map(([v, l]) => (
                            <div key={l}>
                                <div className={ styles.hpStatVal } >{v}</div>
                                <div className={ styles.hpStatLbl } >{l}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={ styles.hpHeroVisual } >

                    <div className={ styles.hpCardStack } >
                        <div className={`${ styles.hpMockCard } ${ styles.back }`}>
                            <div className={ styles.hpMcTag }>Python Track</div>
                            <div className={ styles.hpMcTitle }>Intro to Algorithms</div>
                            <div className={ styles.hpMcModules }>
                                {["Arrays & Loops", "Sorting", "Recursion", "Big-O Notation"].map((m, i) => (
                                    <div className={ styles.hpMcMod } key={m}>
                                        <div className={`${styles.hpMcModDot}${i < 2 ? ` ${styles.done}` : ""}`} />
                                        {m}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={`${ styles.hpMockCard } ${ styles.front }`}>
                            <div className={ styles.hpMcTag }>Currently learning</div>
                            <div className={ styles.hpMcTitle }>Data Science with Python</div>
                            <div className={ styles.hpMcBarWrap }>
                                <div className={ styles.hpMcBarLbl }>
                                    <span>Progress</span><span>68%</span>
                                </div>
                                <div className={ styles.hpMcBarBg }>
                                    <div className={ styles.hpMcBarFill } style={{ width: "68%" }} />
                                </div>
                            </div>
                            <div className={ styles.hpMcModules } style={{ marginTop: "1rem" }}>
                                {["Pandas basics", "Data visualization", "Statistical analysis", "ML intro"].map((m, i) => (
                                    <div className={ styles.hpMcMod } key={m}>
                                        <div className={`${styles.hpMcModDot}${i < 3 ? ` ${styles.done}` : ""}`} />
                                        {m}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeHero;